import React from 'react'
import { connectPagination } from 'react-instantsearch-dom'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import Button from '../../atoms/Button/Button'
import IconButton from '../../atoms/Button/IconButton'
import Icon from '../../atoms/Icon'
import ButtonGroup from '../../atoms/Search/PaginationButtonGroup'

const Pagination = ({ currentRefinement, nbPages, refine, limit = 5 }) => {
  const start =
    Math.floor(
      (currentRefinement % limit === 0 ? currentRefinement - limit : currentRefinement) / limit,
    ) * limit
  const end = Math.min(start + limit, nbPages)

  const pages = []
  for (let i = start; i < end; i++) pages.push(i + 1)

  return pages.length > 0 ? (
    <ButtonGroup>
      <IconButton
        outline
        disabled={currentRefinement === 1}
        type='gray500'
        onClick={() => refine(currentRefinement - 1)}
      >
        <Icon icon={faChevronLeft} />
      </IconButton>
      {pages.map(page => (
        <Button
          key={page}
          outline={page !== currentRefinement}
          type={page === currentRefinement ? 'primary' : 'gray500'}
          onClick={() => refine(page)}
        >
          {page}
        </Button>
      ))}
      <IconButton
        outline
        disabled={nbPages === currentRefinement}
        type='gray500'
        onClick={() => refine(currentRefinement + 1)}
      >
        <Icon icon={faChevronRight} />
      </IconButton>
    </ButtonGroup>
  ) : null
}

export default connectPagination(Pagination)
